<script>
  /**
   * @overview 添加素材二级目录
   *
   * @author retro
   */
  import mapUtils, { $http, $token, $form, $list } from "@/utils";
  import * as materailManageServer from '../../api/materialManage';
  import * as gameManageServer from '../../api/gameManage';

  export default {
    name: "AddTwoMenuGame",

    props: {
      visible: {
        type: Boolean,
        default: false,
      },

      data: {
        type: Object,
        default: null,
      },
      parentId: {
        type: [String, Number],
      },
      // 是否是模版
      isTemp: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      loading: false,
      formData: {
        name: '',
      },
      rules: {
        name: [{ required: true, message: '请输入' }],
      },
    }),
    methods: {
      submit() {
        this.$refs.form.validate((res) => {
          if (res) {
            this.addScene();
          }
        });
      },
      async addScene() {
        const self = this;
        const obj = { name: self.formData.name, parent_type_id: this.parentId };
        console.log(this.parentId);
        let res = null;
        try {
          // 如果是课中游戏模版 添加目录的话 请求模版接口
          if (this.isTemp) {
            res = await gameManageServer.addGameType(obj);
          } else {
            switch (this.parentId) {
              case 30:
                res = await materailManageServer.addResourceType(obj);
                break;
              case 666:
                // 课后添加的时候父级id都为0
                obj.parent_type_id = 0;
                res = await gameManageServer.addGameAfter(obj);
                break;
              default:
                res = await gameManageServer.addGameTypes(obj);
            }
          }
          console.log(res);
          if (res && res.data && res.data.message) {
            this.$message.error(`${res.data.message}`);
          } else {
            this.$emit('success', this.formData.name);
            this.cancel();
          }
        } catch (e) {
          this.$message.error('添加失败');
        }
        // const self = this;
        // const res = await gameManageServer.addGameTypes({ name: self.formData.name, parent_type_id: this.parentId });
        // if (res) {
        //   this.$emit('success', this.formData.name);
        //   this.cancel();
        // } else {
        //   this.$message.error('添加失败');
        // }
      },
      cancel() {
        this.$emit("update:visible", false);
        setTimeout(() => {
          this.formData.name = '';
        }, 200);
        setTimeout(() => {
          this.$refs.form.clearValidate();
        }, 500);
      },
    },
  };
</script>

<template>
  <el-dialog
    :show-close="false"
    :visible="visible"
    width="550px"
    class="course-list-editor"
  >
    <div slot="title">
      新建目录
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
    >
      <el-form-item
        label="名称"
        prop="name"
      >
        <el-input
          v-model="formData.name"
          placeholder="输入内容"/>

      </el-form-item>
    </el-form>

    <AppFormSubmit
      slot="footer"
      :submitting="loading"
      @submit="submit"
      @cancel="cancel"
    />
  </el-dialog>
</template>

<style lang="postcss" scoped>
</style>
